export default {
    farm: {
        locationType: "Location Type",
        viewLocation: "View Location",
        Circular: "Circular",
        Polygon: "Polygon",
        cropName: "Crop name",
        selectFarmToEnableCalenderView: 'Select farm to enable calendar view',
        streetNo: "Street No.",
        UPDATEGEOFENCEFORTHISFARM: "Update Geofence for this farm",
        AddZonestothisfarm: "Add zones to this farm",
        ViewZonestothisfarm: "View zones to this farm",
        personal: "Personal",
        community: "Community",
        searchEvents: "Search Events",
        farmerId: "Farmer Id",
        farmAddress: "Farm Location Address",
        farmID: "Farm ID",
        farmIdPlaceHolder: "Enter Farm ID",
        onTheFarm: "On the Farm",
        userRoles: "User Roles",
        adduser: "Add User",
        addAuser: "Add a User",
        uploadUsers: "Upload Users",
        addNewUser: "Add New User",
        selectDept: "Select Department",
        selectRole: "Select Role",
        editUser: "Edit User",
        totalFarms: "Total Farms",
        NoAnimalsRegisteredForthisFarm: "No Animals are Registered for this Farm",
        farmsPerPage: "Farms per page",
        regularFarms: "Regular Farms",
        farmRegisteredProducts: "Farm Registered Products",
        searchByFarmNameAndId: "Search by Farm Name and Id",
        loadingProductsPleaseWait: "Loading Products... Please wait",
        farmName: "Farm Name",
        nameOfTheFarm: "Name of the farm",
        farmLocation: "Farm Location",
        productName: "Product Name",
        stockStatus: "Stock Status",
        inStock: "In Stock",
        searchByProductName: "Search By Product Name",
        productCategory: "Product Category",
        products: "Products",
        farms: "Farms",
        zones: "Zones",
        registerAfarm: "Register a Farm",
        govtRegistry: "Govt. Registry",
        cooperativeId: "Cooperative/Union ID",
        cooperativeName: "Cooperative/Union Name",
        farmType: "Farm Type",
        contractMating: "Contract Mating",
        customization: "Customization",
        recordsPerpage: "Records per Page",
        restoreDefault: "Restore Default",
        apply: "Apply",
        CommunityName: "Community Name",
        corporateName: "Corporate Name",
        corporateRegistrationNum: "Corporate Registration No",
        corporateMailingAddress: "Corporate Mailing Address",
        communityName: "Community Name",
        searchState:
          "Search by Farm ID, Gov. Registry, Cooperative ID, Farm Type, Contract Mating",
        farmOwner: "Farm Owner",
        govRegistrationNo: "Govt Registration Number",
        farmInformation: "Farm Information",
        ownershipType: "Ownership Type",
        farmLicenseInformation: "Farm License Information",
        licenseNumber: "License Number",
        licenseExpiryDate: "License Expiry Date",
        regulatorName: "Regulator Name",
        regulatorRepresentativeName: "Regulator Representative Name",
        farmLocationSize: "Farm Location & Size",
        productionSystem: "Farming System",
        productionSystemNew: "Production System",
        goals: "Goal(s)",
        country: "Country",
        city: "Village/Town/City",
        latitude: "Latitude",
        longitude: "Longitude",
        farmNumber: "Farm Number",
        postal: "Postal/Zip Code",
        houseNumber: "House Number",
        farmRegistration: "Farm Registration",
        cancel: "Cancel",
        register: "Register",
        ok: "ok",
        totalFarmSize: "Total Farm Size",
        farmGeographicLocation: "Farm Geographic Location",
        perimeterPointLongitude: "Perimeter Point Longitude",
        perimeterPointLatitude: "Perimeter Point Latitude",
        perimeterPointLabel: "Perimeter Point Label",
        perimeterLength: "Perimeter Length",
        farmLatitude: "Farm Latitude",
        farmLongitude: "Farm Longitude",
        editFarm: "Edit Farm",
        update: "Update",
        editAfarm: "Edit a farm",
        nextFarm: "Next Farm",
        nameoftheFarm: "Name of the Farm",
        addNewLocation: "Add New Location",
        registerAProduct: " Register A Product",
        farmProducts: "Farm Products",
        calf: "Calf",
        steer: "Steer",
        heifer: "Heifer",
        sire: "Sire",
        dam: "Dam",
        registerAnAnimal: "Register An Animal",
        farmAnimals: "Farm Animals",
        farm_type: "Farm-type",
        farm_Owner: "Farm-Owner",
        dateOfRegistration: "Date Of Registration",
        dataIsNotAvailableForThisFarm: "Data Is Not available for this Farm",
        registerNewProduct: "Register A New Product",
        information: "Information",
        licenseInfo: "License Info",
        locationInfo: "Location Info",
        geoLocation: "Geo Location",
        perimeterLengthState: "Length of Farms Perimeter (fence length)",
        totalFarmSizeState: "Size of a Farm",
        productionSystemState: "Production System used in the Farm",
        contractMatingState:
          "Code of Contract Mating Programme in which the Farm Participate.",
        ownershipTypeState: "Type of Ownership",
        regulatorRepresentativeNameState:
          "Name of the person representing regulator who released the license",
        regulatorNameState: "Name of regulator which released the license",
        licenseExpiryDateState: "Date when the current License is Expired",
        licenseNumberState: "License Number released by Regulator",
        plotNumberState: "House number of the farm.",
        plotNumber: "Farm Number",
        streetStatement: "Street name of the farm.",
        cityStatement: "City where the farm is located in.",
        farmLocationAddressInfo:
          "The place where the farm undertakes its main agricultural activity.",
        provinceStateInfo:
          "A principal administrative division of a country or empire.",
        cityInfo:
          "A  clustered human settlement or community and associated buildings, larger than a hamlet and smaller than a town, situated in a rural area.",
        streetNumberInfo: "Street Number",
        totalFarmSizeInfo: "Total Size of Farm ",
        areaUOMInfo:
          "The unit of measurement for the farm size e.g. Hectare, Acre etc",
        perimeterLengthInfo: "Total Perimeter of Farm ",
        permiterUOMInfo:
          "The unit of measurement for the farm perimeter e.g. Centimetre, Metre etc",
    
        stateStatement: "Region of the country where the farm is located in.",
        countryState: "Country where the farm is located in.",
        farmStateInfo: "Farm location address",
        perimeterPointLongitudeState: "Longitude of one point on farm.",
        perimeterPointLatitudeState: "Latitude of one point on farm.",
        perimeterPointLabelState: "Label of Point.",
        farmLongitudeState: "Longitude of the farm.",
        farmLatitudeState: "Latitude of the farm.",
        deleteFarm: "Delete Confirmation",
        confirmDeleteFarm: "Are you sure you want to delete this farm?",
    
        farmNameH: "Name of farm",
        farmTypeH:
          "The type of the farm where different activities are carried out.",
        farmOwnerH:
          "Name of owner of a farm (auto-generate Farmer name entering info)",
        ownershipTypeH:
          "The type of farmers who own/control the land they farm and those who do not.",
        govtRegNumbH: "Registry number of the farm which was assigned by regulator",
        contractMatingH:
          "Code of contract mating programm which the farm participate in",
        productionSystemH: "What the production system is used on the farm",
        cooperativeIDH: "ID of a cooperative which the farm is a member of ",
        licenseNumberH:
          "Identifying number on a licence released by regulator that identifies it with the owner.",
        licenseExpiryDateH: "Date when the current license is expired",
        regularNameH: "Name of regulator which released the license",
        regularRepName:
          "Name of the person representing regulator who released the license",
        countryH: "Country where the farm is located in.",
        stateH: "Region of the country where the farm is located in.",
        cityH: "City where the farm is located in.",
        streetH: "Street name of the farm.",
        houseNumberH: "House number of the farm.",
        totalFarmSizeH:
          "Farm size is the sum of land that is currently cultivated by the farm including land under fallow but excluding land under natural vegetation, trees or pasture.",
        farmLatitudeH:
          "Is the measurement of distance north or south of the Equator. It is measured with 180 imaginary lines that form circles around Earth east-west, parallel to the Equator",
        farmLongitudeH: "It measures distance east or west of the prime meridian.",
        perimeterLengthH: "Length of farms perimeter (fence length)",
        perimeterPointLabelH:
          "Label of point. Using three parameters (latitude, longitude and label) we describe perimeter of farm and any segment inside of the farm.",
        perimeterPointLatH: "Latitude of one point on farm",
        perimeterPointLongH: "Longitude of one point on farm",
        street: "Street",
        registration: {
          regulatorName: "Name of regulator which released the license",
          perimeterPointLabel:
            "Label of point. Using three parameters (latitude, longitude and label) we describe perimeter of farm and any segment inside of the farm.",
          perimeterPointLatitude: "Latitude of a perimeter point",
          perimeterPointLongitude: "Longitude of a perimeter point",
          farmID: "The Identification Number given to the livestock farm",
          farmName: "The name given to the livestock farm",
          CommunityName:
            "A name given to a  group of people with a common characteristic or interest living together within a larger society",
          farmType:
            "Farm type can be classified (grouped) according to livestock grown and how it is grown",
          farmOwner: "Any person who owns or controls the operations of a farm",
          ownershipType:
            "The type of farmers who own/control the farm and those who do not",
          govtRegistrationNumber:
            "Number given by government organisation in which farm registered",
          licenseNumber: "License number released by regulator",
          licenseExpiryDate: "The day the licence becomes invalid for recognition",
          regulatorRepresentativeName: "Name of the Regulator Representative",
        },
        addFarm: "Add Farm",
        importFarmsInBulk: "Import Farms in Bulk",
        importFarms: "Import Farms",
        importingNote:
          "Your uploaded file is currently being processed.\nDon't click on cancel, close or refresh this page to avoid interruption.",
        bulkImportNote:
          "Download and use the below templates to bulk import farms.",
        importCompleted: "Import Completed",
        importantNoteDetail:"Please use the provided templates above for bulk uploads. Other formats will result in failure.",
        farmerFirstName: "Farmer First Name",
        farmerMiddleName: "Farmer Middle Name",
        farmerLastName: "Farmer Last Name",
        iAmNotFarmer: "I'm not the farmer",
        certifications: "Certifications",
        productionType: "Production Type",
        deleted: "Farm deleted successfully.",
        notDeleted: "Farm not deleted.",
        farmTitleDocument: "Farm Title Documents",
        dropHere: "or drag and drop here",
        technicianName: "Technician Name",
        regBy: "Reg. By",
        regDate: "Reg. Date",
        farmRegistrationId: "Farm Registration Id",
        farmerRegistrationId: "Farmer Registration Id",
        farmId: "Farm Id",
        farmerName: "Farmer Name",
        farmOwnershipType: "Farmer Ownership Type ",
        farmGoals: "Farm Goals",
        farmCertifications: "Farm Certifications",
        farmInfo: "Farm Info",
        provinceState: "Province/State",
        streetNumber: "Street Number",
        addGeofenceForThisFarm: "Add geofence for this farm",
        pleaseClickToChooseLocation: "Please click to choose location",
        address: "Address",
        geographicLocation: "Geographic Location",
        searchLocation: "Search Location",
        pleaseChooseOneOfTheOption: "Please choose one of the options",
        useGeoFencingFeature: "Use geofencing feature",
        uploadShapeFile: "Upload a shape file",
        uploadGeofence: "Upload Geofence",
        upload: "Upload",
        reports: "Reports",
        generateReport: "Generate Report",
        avocado: "Avocado",
        avocadoTrees: "Avocado Trees",
        addNewFarmLocation: "Add New Farm Location",
        farmLocationAddress: "Farm Location Address",
        useGeofenceTool: "Use geofence tool",
        geofenceIsRequiredForSatelliteReport:
          "Note:Geofence is required for Satellite Reports",
        enterHere: "Enter here",
        primaryLocation: "Primary Location",
        secondaryLocation: "Secondary Location",
        locationAndSize: "Location and Size",
        farmReports: "Report(s)",
        activities: "Activities",
        search: "Search",
        selectCountry: "Select Country",
        filterByFarmName: "Filter by Farm Name",
        filterByCropType: "Filter by Crop Type",
        filterByStartDate: "Filter by Start Date",
        download: "Download",
        of: "of",
        previousPage: "Previous Page",
        nextPage: "Next Page",
        view: "View",
        activityDetails: "Activity Details",
        activity: "Activity",
        cropType: "Crop Type",
        startDate: "Start Date",
        endDate: "End Date",
        description: "Description",
        close: "Close...",
        farmActivities: "Farm Activities",
        listView: "List View",
        calendarView: "Calendar View",
        scheduledActivities: "Scheduled Activities",
        completedActivities: "Completed Activities",
        deforestationReports: "Deforestation Report(s)",
        id: "id",
        locationName: "Location Name",
        createdAt: "Created At",
        etherScanLink: "Blockchain Link",
        overallProb: "Overall Probability",
        addNewZone: "Add New Zone",
        noZoneMessage: "No Zones has been registered yet.",
        noZoneRequest:
          "Please click on Add New Zone to create a Zone for this Farm.",
        locationZone: "Location Zone",
        editFarmLocation: "Edit Farm Location",
        addZone: "Add Zone",
        nameOfTheZone: "Name Of The Zone",
        zoneDetails: "Zone Details",
        perimeter: "Perimeter",
        areaUnit: "Area Unit",
        area: "Area",
        zoneName: "Zone Name",
        farmGeofence: "Farm Geofence",
        circularGeofence: "Circular Geofence",
        polygonGeofence: "Polygon Geofence",
        radius: "Radius",
        radiusInfo: "Specifies the distance from a central point to the outer edge of a circular area.",
        radiusUnitInfo: "Refers to a standard quantity used as a basis for measurement.",
        actions: "Actions",
        editZone: "Edit Zone",
        numberOfGroups: "Number of Group",
        numberOfTrees: "Number of Trees",
        group: "Group",
        groupName: "Group Name",
        numberOfAnimals: "Number of Animals",
        status: "Status",
        primaryGeofence: "Primary Geofence",
        walkAndMeasure: "walk and measure",
        clearGeofence: "Clear Geofence",
        deleteSelectedVertex: "Delete Selected Vertex",
        basicInformation: "Basic Information",
        geofenceCategoryName: "Geofence Category Name",
        geofenceName: "Geofence Name",
        farmRadius: "Farm Radius",
        locationDisabledMessage:
          "Your location is disabled. Please search your location from left menus.",
        yourDistanceIs: "Your distance is",
        selectFarmToEnableCalendarView: 'Please select a farm to enable the calendar view',
        noFarm: 'No farm has been registered yet.',
        noFarmDescription: 'Please click on below buttons to get started.',
    
        searchFarmName: "Search by Farm Name",
        pleaseSelectFarmType: "Please select farm type.",
    
        organic: "Organic",
        conventional: "Conventional",
      },

      farm_upload_validation: {
        Farm_Upload_Validation: "Farm Upload Validation",
        Bulk_Upload_Field_Validation: "Bulk Upload Field Validation",
        Go_Back: "Go Back",
        Input_Field: "Input Field",
        Validation_Message: "Validation Message",
        Description: "Description",
        Action: "Action",
        Validate: "Validate",
        Farm_Name: "Farm Name",
        Farm_Registration_ID: "Farm Registration ID",
        Farmer_First_Name: "Farmer First Name",
        Farmer_Last_Name: "Farmer Last Name",
        Farmer_Registration_ID: "Farmer Registration ID",
        User_Email_Address: "User Email Address",
        Shared_Access_With: "Share Access With",
        Ownership_Type: "Ownership Type",
        Goal_s: "Goal(s)",
        Production_Type: "Production Type",
        Certifications: "Certifications",
        Total_Farm_Size: "Total Farm Size (e.g., 50 acres or 20 hectares)",
        Farm_Address: "Farm Address",
        Farm_GPS_Coordinates: "Farm GPS Coordinates (e.g., 40.7128, -74.0060)",
        Country: "Country",
        Province_State: "Province/State",
        Village_Town_City: "Village/Town/City",
        Farm_Geofence: "Farm Geofence (Polygon or Circle)",
        Helper_Messages: {
          Farm_Name: {
            Description: "The official name of the farm as registered with authorities or known publicly.",
            Usage: "This name is used for identification and branding purposes."
          },
          Farm_Registration_ID: {
            Description: "A unique identifier for the farm registration.",
            Assignment: "Assigned by a governmental or agricultural body."
          },
          Farmer_First_Name: {
            Description: "The first name of the farmer who owns or operates the farm.",
            Usage: "This is used for personal identification and legal documentation.",
            Instructions_1: "Enter the farmer's first name.",
            Instructions_2: "Avoid abbreviations, numbers or special characters.",
            Instructions_3: "If left blank, the system will auto-generate 'Unknown' as the first name."
          },
          Farmer_Last_Name: {
            Description: "The last name (surname) of the farmer.",
            Usage: "This is used for personal identification and legal documentation.",
            Instructions_1: "Enter the farmer's last name.",
            Instructions_2: "Avoid abbreviations, numbers or special characters.",
            Instructions_3: "Check that the last name is included and correctly formatted.",
            Instructions_4: "If left blank, the system will auto-generate 'Unknown' as the last name."
          },
          Farmer_Registration_ID: {
            Description: "A unique identifier for the farmer's registration.",
            Assignment: "Typically assigned by a regulatory or agricultural body.",
            Usage: "This ID is used for formal registration and compliance purposes.",
            Instructions_1: "Enter the Farmer Registration ID to avoid duplicates.",
            Instructions_2: "Ensure it is unique and correctly formatted.",
            Instructions_3: "If left blank, the system will prompt you to provide it to prevent creating duplicate entries (non-mandatory)."
          },
          User_Email_Address: {
            Description: "This is an email of a user who will be assigned to the farm or will have primary access to the farm.",
            Context: "This could be either a farmer or a technician.",
            Usage: "This email is used for communication, notifications, and account management.",
            Instructions_1: "Enter a valid email (e.g., example@domain.com).",
            Instructions_2: "Check for typos and spaces.",
            Instructions_3: "Verify the email format is correct.",
            Instructions_4: "If left blank, the system should prompt the user to provide a valid email (non-mandatory)."
          },
          Shared_Access_With: {
            Description: "Specifies individuals or entities with whom access to the farm's data is shared.",
            Usage: "Allows for controlled collaboration based on roles and responsibilities."
          },
          Ownership_Type: {
            Description: "Indicates the type of ownership of the farm.",
            Examples: "Examples include individual, partnership, or corporation.",
            Usage: "This is for legal and administrative purposes."
          },
          Goal_s: {
            Description: "Describes the primary objectives of the farm."
          },
          Production_Type: {
            Description: "Indicates the primary agricultural activity of the farm, such as organic or conventional."
          },
          Certifications: {
            Description: "Select certifications related to the farm, such as organic certification, fair trade, or GAP."
          },
          Total_Farm_Size: {
            Description: "Total area of the farm (acres or hectares). Used for resource planning, regulatory reporting, and market analysis."
          },
          Farm_Address: {
            Description: "Enter the complete address of the farm, including street address, city, state, and postal code. Used for location identification and service delivery."
          },
          Farm_GPS_Coordinates: {
            Description: "Geographical coordinates (latitude and longitude) of the farm location. Helps in locating the farm on a map."
          },
          Country: {
            Description: "The country where the farm is located."
          },
          Province_State: {
            Description: "The province or state where the farm is located. Options depend on the selected country."
          },
          Village_Town_City: {
            Description: "The village, town, or city where the farm is located."
          },
          Farm_Geofence: {
            Description: "The geofence mapping of the farm includes the boundaries of the farm on a map. Defines the boundary of the farm using a geofence (polygon or circular)."
          }
        },
        validation: {
          farmNameRequired: "Farm name is required",
          farmNameMaxLength: "Farm name must be less than 50 characters",
          farmNameExists: "Farm name already exists",
          registrationIDRequired: "Registration ID is required",
          registrationIDMaxLength: "Registration ID must be less than 20 characters",
          firstNameRequired: "Farmer’s first name is required",
          firstNameLettersOnly: "First name must contain only letters",
          lastNameRequired: "Farmer’s last name is required",
          lastNameLettersOnly: "Last name must contain only letters",
          emailRequired: "Email is required",
          emailValid: "Enter a valid email (e.g., example@domain.com)",
          emailNoSpaces: "Email should not contain spaces",
          sharedAccessWithRequired: "Please select at least one entity or leave blank",
          ownershipTypeRequired: 'Ownership type is required or will default to "Unknown"',
          farmGoalsMaxLength: "Farm goals must be less than 500 characters",
          productionTypeRequired: "Please select a production type or leave blank",
          certificationsRequired: "Please select at least one entity or leave blank",
          farmSizePositive: "Farm size must be a positive numeric value",
          farmSizeUnit: "Specify unit (e.g., 50 acres or 20 hectares)",
          farmAddressFormat: "Invalid address. Format: Street, City, State, Postal Code",
          farmGPSCoordinatesFormat: "Invalid GPS coordinates. Format: Latitude, Longitude (e.g., 40.7128, -74.0060)",
          countryRequired: "Country is required",
          countryLettersOnly: "Country name must contain only letters",
          provinceStateRequired: "Province/State is required",
          provinceStateLettersOnly: "Province/State must contain only letters",
          villageTownCityRequired: "Village/Town/City is required",
          villageTownCityLettersOnly: "Village/Town/City must contain only letters",
          farmGeofencePolygon: "Invalid polygon points. Format: Latitude,Longitude pairs",
          farmGeofenceCircle: "Invalid geofence. Format: Center Latitude,Longitude;Area in hectares"
        }
      },
      

      buySell: {
        farmerName: "Farmer Name",
        location: "Location",
        country: "Country",
        gender: "Gender",
        noOfOrdersSold: "No of Orders Sold",
        noOfPurchaseOrders: "No of Purchase Orders",
        totalPurchaseSaleVolume: "Total Purchase/Sale Volume",
        totalAvgValue: "Total Avg Value",
        searchOrderByID: "Search Order By ID",
        totalNumberofOrders: "Total Number of Orders",
        totalNumberOfTransactions: "Total Number of Transactions",
        totalWeightOfTransactions: "Total Weight of Transactions",
        totalMonetaryValue: "Total Monetary Value",
        averagePriceperKg: "Average Price Per Kg",
        sellingAvgValuePerKg: "Average Selling Price Per Kg",
        purchaseAvgValuePerKg: "Average Purchase Price Per Kg",
      },
    
      plantation: {
        farmerName: "Farmer Name",
        phoneNumber: "Phone Number",
        plantationName: "Plantation Name",
        farm: "Farm",
        location: "Location",
        updatePlantationStatus: "Update Plantation Status",
        update: "UPDATE",
        plantationStatus: {
          pending: "Pending",
          approved: "Approved",
          rejected: "Rejected",
          completed: "Completed",
        },
      },
}